//shopify theme dev -s straand.myshopify.com -t 129949794444 -e
PetiteVue.createApp({
	// exposed to all expressions
	products: sub_products,
	time_interval: initial_time,
	selected_products: [],
	CURRENCY_VALUE: currency,
	// methods
	handleProductSubmit(e) {
		e.preventDefault()
		var form = e.target
		var product_input = form.querySelector('[name="id"]')
		var quantity_input = form.querySelector(".quantity__input")
		var atc_button = form.querySelector(".button")

		if (!product_input || !quantity_input) return

		if (!atc_button.classList.contains("loading")) {
			atc_button.classList.add("loading")
			atc_button.querySelector(".loading-overlay__spinner").classList.remove("hidden")
		}

		var quantity = parseInt(quantity_input.value)
		var product_id = parseInt(product_input.dataset.productid)

		//check to see if product is already added
		var current_product = this.selected_products.find((selected) => {
			return selected.product.id === product_id
		})

		if (current_product && current_product.variant) {
			//already has product => increase quantity
			var selected_updated = this.selected_products.map((selected) => {
				if (selected.product.id === product_id) {
					let total_qty = selected.quantity + quantity
					return {
						...selected,
						quantity: total_qty,
					}
				}

				return selected
			})

			this.selected_products = selected_updated
		} else {
			var matching_product = this.products.find((prod) => {
				return prod.id === product_id
			})

			//saving selling plan here means that it will be set at the time of pressing atc. changing period after will have no affect. makes calculating total saving much easier
			var selling_plan = this.findSellingPlan(matching_product)

			var product_obj = {
				variant: parseInt(product_input.value),
				product: matching_product,
				selling_plan,
				quantity,
			}

			console.log(product_obj)
			this.selected_products = [...this.selected_products, product_obj]
		}

		atc_button.classList.remove("loading")
		atc_button.querySelector(".loading-overlay__spinner").classList.add("hidden")

		// scroll into view
		var bundle_details_container = document.querySelector(".sub-form")

		if (bundle_details_container) bundle_details_container.scrollIntoView({ behavior: "smooth", block: "center" })
	},
	handleTimeChange(e) {
		var input = e.target

		this.time_interval = input.value

		var updated_selling_plan = this.selected_products.map((selected) => {
			var new_selling_plan = this.findSellingPlan(selected.product)

			return {
				...selected,
				selling_plan: new_selling_plan,
			}
		})

		this.selected_products = updated_selling_plan

		console.log(input.value)
	},
	handleATC(e) {
		var atc_button = e.target
		atc_button.classList.add("loading")
		atc_button.querySelector(".loading-overlay__spinner").classList.remove("hidden")

		var post_data = {
			items: [],
		}

		this.selected_products.forEach((selected) => {
			//find the matching selling plan

			if (selected.selling_plan.id) {
				//only add product if it has a matching selling plan
				let product_json = {
					id: selected.variant,
					quantity: selected.quantity,
					selling_plan: selected.selling_plan.id,
				}
				post_data.items.push(product_json)
			}
		})

		var cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer")

		var sections = cart.getSectionsToRender().map((section) => section.id)

		post_data.sections = sections

		console.log(post_data)

		if (post_data.items.length == 0) return

		const body = JSON.stringify(post_data)

		fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
			.then((response) => response.json())
			.then((response) => {
				if (Object.keys(response.sections).length > 0) {
					//render card draw
					cart.renderContents(response)
				} else {
					//send to cart page
					window.location = window.routes.cart_url
				}
			})
			.catch((error) => {
				debugger
			})
			.finally(() => {
				// this.submitButton.classList.remove('loading');
				atc_button.classList.remove("loading")
				atc_button.querySelector(".loading-overlay__spinner").classList.add("hidden")

				if (cart && cart.classList.contains("is-empty")) cart.classList.remove("is-empty")
				// if (!this.error) this.submitButton.removeAttribute('aria-disabled');
				// this.querySelector('.loading-overlay__spinner').classList.add('hidden');
			})
	},
	price(cents) {
		return Shopify.formatMoney(cents, this.CURRENCY_VALUE)
	},
	orderTotal() {
		var total_price = this.selected_products.reduce((accum, curr) => {
			return accum + this.sellingPlanPrice(curr) * curr.quantity
		}, 0)

		return total_price
	},
	orderSaving() {
		var base_price = this.selected_products.reduce((accum, curr) => {
			//how much is saved
			return accum + curr.product.price * curr.quantity
		}, 0)
		return base_price - this.orderTotal()
	},
	sellingPlanPrice(selected_product) {
		if (!selected_product.selling_plan) return
		var saving_amount = 0
		var adjustment_type = selected_product.selling_plan.price_adjustments[0].value_type
		var adjustment_value = selected_product.selling_plan.price_adjustments[0].value

		switch (adjustment_type) {
			case "percentage": {
				saving_amount = selected_product.product.price * (1 - adjustment_value / 100)
				break
			}
			case "fixed_amount": {
				saving_amount = selected_product.product.price - adjustment_value
				break
			}
			case "price": {
				saving_amount = adjustment_value
				break
			}
		}

		return saving_amount
	},
	findSellingPlan(product_obj) {
		var selling_plan = {}

		for (let i = 0; i < product_obj.selling_plan_groups.length; i++) {
			const plan_obj = product_obj.selling_plan_groups[i]
			for (let j = 0; j < plan_obj.selling_plans.length; j++) {
				const plan = plan_obj.selling_plans[j]
				let lowercase_name = plan.name.toLowerCase()
				console.log(lowercase_name)
				if (lowercase_name.includes(this.time_interval)) {
					selling_plan = plan
					break
				}
			}
		}

		return selling_plan
	},
	removeProduct(product_id) {
		var updated_array = this.selected_products.filter((selected) => {
			return selected.product.id != product_id
		})
		this.selected_products = [...updated_array]
	},
	//settings
	$delimiters: ["$[", "]"],
}).mount("#app")
